import { Card, Button } from "@chakra-ui/react"

const DisplayCardComponent = (props: any) => {

    const title: string = props.title
    const buttonText: string = props.buttonText
    const buttonFn = props.buttonFn

    return (
        <>
        <Card.Root style={{maxWidth: "320px"}}>
            <Card.Body gap="2" bg="grackle.900">

                <Card.Title mt="2"  color="whiteAlpha.900">{title}</Card.Title>
                
                <Card.Description color="whiteAlpha.900">
                    <img src="grackleheart.png" />
                    {props.children}
                </Card.Description>
            </Card.Body>
            <Card.Footer justifyContent="flex-end" bg="grackle.900">
                <Button 
                    _hover={{borderColor: "grackle.400", borderWidth:"2px"}}
                    _focus={{bg: "grackle.100"}}
                    bg="grackle.800"  
                    color="whiteAlpha.900"
                    onClick={() => {buttonFn()}}
                >
                    {buttonText}
                </Button>
            </Card.Footer>
        </Card.Root>
    </>
    )

}

export default DisplayCardComponent